__turbopack_context__.v({
  "Change": "eG2y4a_Change",
  "Change--Negative": "eG2y4a_Change--Negative",
  "Container": "eG2y4a_Container",
  "DataWrapper": "eG2y4a_DataWrapper",
  "Description": "eG2y4a_Description",
  "Error": "eG2y4a_Error",
  "Image": "eG2y4a_Image",
  "LoaderWrapper": "eG2y4a_LoaderWrapper",
  "Percentage": "eG2y4a_Percentage",
  "Root--Empty": "eG2y4a_Root--Empty",
  "Root--LongUnitText": "eG2y4a_Root--LongUnitText",
  "Root--Percentage": "eG2y4a_Root--Percentage",
  "Text": "eG2y4a_Text",
  "Title": "eG2y4a_Title",
  "TitleWrapper": "eG2y4a_TitleWrapper",
  "Unit": "eG2y4a_Unit",
  "Value": "eG2y4a_Value",
  "skeleton-loading": "eG2y4a_skeleton-loading",
});
